var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.only !== 'sticky' || _vm.hasStickyNotes)?_c('div',{staticClass:"client-notes-wrap"},[(_vm.only === 'sticky')?_c('h4',[_vm._v("Important Client Notes")]):_vm._e(),_vm._v(" "),_c('note-list',{attrs:{"notes":_vm.notes,"only":_vm.only}}),_vm._v(" "),(_vm.only !== 'sticky')?_c('add-note'):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }